import { createElement, memo } from '@max/max';
import Image from '@hfe/max-image';
import View from '@hfe/max-view';
import './index.scss';
function Empty() {
    return <View className="traffic-filter-empty-container">
      <Image className="traffic-filter-empty-image" source={{
        uri: 'https://p0.meituan.net/ingee/9d7f1f5c4b065dac03c2e940a3c7e5c067576.png'
    }}/>
      
    </View>;
}
export default memo(Empty);
